import complaint from "./complaint";
import system from "./system";
import setting from "./setting";
import memberRegister from "./member-register";
import SupplierStaffs from "./supplier-staffs";
import email from "./email";
import product from "./product";
import task from "./task-management";
import emartmall from "./emartmall";
import giftCardEvent from "./event";
import order from "./order";
import { NavItemType } from "types";

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [
    email,
    complaint,
    system,
    emartmall,
    memberRegister,
    SupplierStaffs,
    product,
    task,
    giftCardEvent,
    setting,
    order,
  ],
};

export default menuItems;
